var Student = "Учащийся";
var jobRole = {
	"Job role": "Должность",
	"Academic / Researcher": "Исследователь / ученый",
	"Advisor / Consultant": "Советник / консультант",
	"Business Executive": "Руководитель коммерческой организации",
	"Developer / Engineer": "Разработчик / инженер",
	"Entrepreneur (Founder/Co-Founder)": "Предприниматель (учредитель/соучредитель)",
	"IT Executive": "Директор по ИТ",
	"IT Professional or Technical Manager": "ИТ-специалист или технический менеджер",
	"Press / Media Analyst": "Представитель прессы / медиа-аналитик",
	"Sales / Marketing": "Представитель отдела продаж / маркетинга",
	Student: Student,
	"Solution or Systems Architect": "Специалист по архитектуре решений или систем",
	"System Administrator": "Системный администратор",
	"Venture Capitalist": "Специалист по венчурным капиталам"
};

export { Student, jobRole as default };
